export const CANONICAL_LOCAL_FRONTEND_ORIGIN = 'https://localhost:3000';

type LocalLocation = Pick<Location, 'hash' | 'hostname' | 'origin' | 'pathname' | 'search'>;

const LOCAL_HOSTNAMES = new Set(['localhost', '127.0.0.1', '::1', '[::1]']);

export const getCanonicalLocalFrontendRedirect = (
  location: LocalLocation,
  configuredOrigin = CANONICAL_LOCAL_FRONTEND_ORIGIN,
): string | null => {
  if (!LOCAL_HOSTNAMES.has(location.hostname)) {
    return null;
  }
  const target = new URL(configuredOrigin);
  if (
    target.protocol !== 'https:' ||
    target.hostname !== 'localhost' ||
    !target.port ||
    target.username ||
    target.password ||
    target.pathname !== '/' ||
    target.search ||
    target.hash
  ) {
    throw new Error('Local frontend origin must be an explicit HTTPS localhost origin');
  }
  if (location.origin === target.origin) {
    return null;
  }
  return `${target.origin}${location.pathname}${location.search}${location.hash}`;
};
